exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-button[data-v-5cf46d1b] {\n  -moz-appearance: none;\n       appearance: none;\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: none;\n  color: #BE2143;\n  padding: 0.5rem 0.7rem;\n  width: 8.8rem;\n  margin: 2rem auto 0;\n  display: block;\n  font-family: \"Axiforma\", sans-serif;\n  cursor: pointer;\n}", ""]);

// exports
